export const alertTypes = {
  error: "error",
  warning: "warning",
  success: "success",
  info: "info",
};
